import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  Radio,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { dropDownSelectStyle, radioButton } from '../ReusableStyles/CommonStyles'; // Adjust the path as necessary
import ReplayIcon from '@mui/icons-material/Replay';
import { set } from 'lodash';
const textFieldStyleProps = {
  style: {
    fontSize: '12px',
    width: '58px',
    backgroundColor: 'white',
    height: '26px',
  },
};

interface StandingSlidingOptionsProps {
  windowFnValues: any;
  setWindowFnValues: (fn: (prev: any) => any) => void;
  percentages: string[];
  standingSlidingAggregation: string[];
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const StandingSlidingOptions: React.FC<StandingSlidingOptionsProps> = ({
  windowFnValues,
  setWindowFnValues,
  percentages,
  standingSlidingAggregation,
  handleKeyDown,
}) => {
  const dropdownSelections = {
    first:
      windowFnValues.standingSlidingReferenceWn === 'First'
        ? 'isFirst'
        : windowFnValues.standingSlidingReferenceWn === 'Last'
          ? 'isLast'
          : (windowFnValues.standingSlidingPreInc ?? 0) < 0
            ? 'Previous'
            : windowFnValues.standingSlidingPreInc === 0
              ? 'Current'
              : 'Next',
    second:
      windowFnValues.standingSlidingNextInc === undefined ||
      windowFnValues.standingSlidingNextInc === 0
        ? 'Current'
        : windowFnValues.standingSlidingNextInc < 0
          ? 'Previous'
          : 'Next',
  };
  const [isCustomSelected, setIsCustomSelected] = useState({
    first:
      Math.abs(windowFnValues.standingSlidingPreInc ?? 0) > 5 &&
      Math.abs(windowFnValues.standingSlidingPreInc ?? 0) !== 999,
    second:
      !!windowFnValues.standingSlidingNextInc &&
      Math.abs(windowFnValues.standingSlidingNextInc) > 5 &&
      Math.abs(windowFnValues.standingSlidingNextInc) !== 999,
  });
  const absPrev = Math.abs(windowFnValues.standingSlidingPreInc ?? 10);
  const absNext = windowFnValues.standingSlidingNextInc
    ? Math.abs(windowFnValues.standingSlidingNextInc)
    : 10;
  const [inputs, setInputs] = useState({
    first: absPrev !== 999 ? absPrev : 10,
    second: absNext !== 999 ? absNext : 10,
  });
  const needSecondRef =
    !windowFnValues.standingSlidingReferenceWn &&
    windowFnValues.standingSlidingNextInc !== undefined;
  const dropDownOptions = ['Previous', 'Current', 'Next'] as const;
  const values = [
    { label: 'All', value: '999' },
    { label: '1st', value: '1' },
    { label: '2nd', value: '2' },
    { label: '3rd', value: '3' },
    { label: '4th', value: '4' },
    { label: '5th', value: '5' },
    { label: 'Custom', value: 'Custom' },
  ];
  const handleChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    const prev = windowFnValues.standingSlidingPreInc || 999;
    const next = windowFnValues.standingSlidingNextInc || 999;
    if (['isFirst', 'isLast'].includes(value)) {
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        standingSlidingReferenceWn: value === 'isFirst' ? 'First' : 'Last',
      }));
      return;
    }
    if (value === 'Current') {
      const isOtherCurrent =
        name !== 'first'
          ? windowFnValues.standingSlidingPreInc === 0
          : windowFnValues.standingSlidingNextInc === 0;
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: 0,
        standingSlidingAggregation: standingSlidingAggregation.includes(
          (windowFnValues.standingSlidingAggregation ?? 'sum').toLowerCase(),
        )
          ? windowFnValues.standingSlidingAggregation
          : 'Sum',
        standingSlidingReferenceWn: null,
        ...(isOtherCurrent && {
          [name !== 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: -999,
        }),
      }));
    } else {
      let modifiedInput = name === 'first' ? prev : next;
      modifiedInput = value === 'Previous' ? -Math.abs(modifiedInput) : Math.abs(modifiedInput);
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: modifiedInput,
        standingSlidingAggregation: standingSlidingAggregation.includes(
          (windowFnValues.standingSlidingAggregation ?? 'sum').toLowerCase(),
        )
          ? windowFnValues.standingSlidingAggregation
          : 'Sum',
        standingSlidingReferenceWn: null,
      }));
    }
  };
  const handleNeedOFSecondRefChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const prev = windowFnValues.standingSlidingPreInc;
    if (checked) {
      setIsCustomSelected((prev) => ({
        ...prev,
        second: false,
      }));
    }

    setWindowFnValues((prevState: any) => ({
      ...prevState,
      standingSlidingNextInc: checked ? (prev === 0 ? 999 : 0) : undefined,
    }));
    // _onChange('standingsvssliding', 1, checked ? 0 : -2, checked ? 'next' : 'trim');
  };
  const handleInputChange = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { name } = event.target;
    const value = inputs[name as keyof typeof inputs] ?? 10;
    let modifiedInput = value < 0 ? 1 : Number(value);
    if (modifiedInput > 100) modifiedInput = 100;
    if (modifiedInput < 1) modifiedInput = 1;
    modifiedInput =
      dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous'
        ? -Math.abs(modifiedInput)
        : Math.abs(modifiedInput);
    setWindowFnValues((prevState: any) => ({
      ...prevState,
      [name === 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: modifiedInput,
    }));
    setInputs((prev) => ({
      ...prev,
      [name]: Math.abs(modifiedInput),
    }));
  };
  const handleDropdownChangeForRow = (event: SelectChangeEvent<string>) => {
    event.preventDefault();
    const { name, value } = event.target;
    if (value === 'Custom') {
      setIsCustomSelected((prev) => ({
        ...prev,
        [name]: true,
      }));
      const value =
        dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous' ? -10 : 10;
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: value,
      }));
      // _onChange('standingsvssliding', name === 'first' ? 0 : 1, value, name === 'first' ? 'prev' : 'next');
    } else {
      let modifiedInput = Number(value);
      modifiedInput =
        dropdownSelections[name as keyof typeof dropdownSelections] === 'Previous'
          ? Math.abs(modifiedInput) * -1
          : modifiedInput;

      setWindowFnValues((prevState: any) => ({
        ...prevState,
        [name === 'first' ? 'standingSlidingPreInc' : 'standingSlidingNextInc']: modifiedInput,
      }));
    }
  };
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { name, value } = event.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const resetReferenceWindow = () => {
    setWindowFnValues((prevState: any) => ({
      ...prevState,
      standingSlidingReferenceWn: null,
      standingSlidingPreInc: -1,
      standingSlidingNextInc: undefined,
    }));
    setIsCustomSelected({
      first: false,
      second: false,
    });
    setInputs({
      first: 10,
      second: 10,
    });
  };
  return (
    <div style={{ width: '100%' }}>
      <div className="MenuSize" style={{ width: '100%' }}>
        <div>
          {percentages.map((option, index) => (
            <div
              className="commonOption2"
              key={index}
              style={{ cursor: 'pointer' }}
              onClick={() =>
                setWindowFnValues((prevState: any) => ({
                  ...prevState,
                  percentage: option,
                }))
              }
            >
              <Radio
                size="small"
                checked={windowFnValues.percentage === option}
                value={option}
                sx={{
                  ...radioButton,
                  marginTop: '0',
                  paddingTop: '0',
                  paddingLeft: '15px',
                }}
              />
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '12px',
                  marginTop: '0',
                  padding: '0 15px 7px 0',
                }}
              >
                {option}
              </Typography>
            </div>
          ))}
        </div>
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBlock: '0.3rem',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              paddingLeft: '15px',
              fontWeight: '600',
              color: 'rgb(96, 96, 96)',
            }}
          >
            Reference Window
          </Typography>
          <Tooltip
            title="Reset reference window to default"
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <ReplayIcon
              sx={{ fontSize: '14px', marginLeft: '5px', cursor: 'pointer' }}
              onClick={resetReferenceWindow}
            />
          </Tooltip>
        </Typography>

        <div
          style={{
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '15px',
              marginLeft: '4px',
            }}
          >
            <Checkbox
              checked
              disabled
              size="small"
              sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
            />

            <Select
              labelId="prev-next-curr-1"
              id="first-dropdown"
              value={dropdownSelections.first}
              onChange={handleChange}
              name="first"
              sx={{ ...dropDownSelectStyle, minWidth: '100px', marginRight: '9px' }}
            >
              <MenuItem key="isFirst" value={'isFirst'}>
                First
              </MenuItem>
              {dropDownOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  disabled={
                    option === 'Current' && needSecondRef && dropdownSelections.second === 'Current'
                  }
                >
                  {option}
                </MenuItem>
              ))}

              <MenuItem key="isLast" value={'isLast'}>
                Last
              </MenuItem>
            </Select>
            {!['isFirst', 'isLast'].includes(dropdownSelections.first) &&
              dropdownSelections.first !== 'Current' &&
              !isCustomSelected.first && (
                <Select
                  labelId="prev-next-curr-1"
                  id="first-dropdown"
                  value={`${Math.abs(windowFnValues.standingSlidingPreInc ?? 999)}`}
                  onChange={handleDropdownChangeForRow}
                  name="first"
                  sx={{ ...dropDownSelectStyle, minWidth: '60px' }}
                >
                  {values.map((option) => (
                    <MenuItem key={option.label} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            {!['isFirst', 'isLast'].includes(dropdownSelections.first) &&
              dropdownSelections.first !== 'Current' &&
              isCustomSelected.first && (
                <TextField
                  type="number"
                  value={Math.abs(inputs.first)}
                  name="first"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                    input: { style: { height: '25px' } },
                    htmlInput: { max: 100 },
                  }}
                  sx={{
                    width: '95%',
                    '& .MuiInputBase-root': {
                      height: '2rem',
                      fontSize: '11px',
                    },
                    '& .MuiTextField-root': {
                      outline: 'none',
                      border: 'none',
                    },
                    border: 'none',
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#2bb9bb',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '16.5px 14px', // Consistent padding for all browsers
                    },
                    // Firefox-specific styling
                    '@supports (-moz-appearance: none)': {
                      '& .MuiOutlinedInput-input': {
                        padding: '16.5px 2px 16.5px 14px',
                      },
                    },
                  }}
                  onBlur={handleInputChange}
                  onChange={onInputChange}
                />
              )}
          </Box>
          <Box
            sx={{
              display: !['isFirst', 'isLast'].includes(dropdownSelections.first) ? 'flex' : 'none',
              alignItems: 'center',
              marginRight: '15px',
              marginLeft: '4px',
            }}
          >
            <Checkbox
              checked={needSecondRef}
              onChange={handleNeedOFSecondRefChange}
              size="small"
              sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
            />

            <Select
              disabled={!needSecondRef}
              labelId="prev-next-curr-2"
              id="second-dropdown"
              value={dropdownSelections.second}
              onChange={handleChange}
              name="second"
              sx={{ ...dropDownSelectStyle, minWidth: '100px', marginRight: '9px' }}
            >
              {dropDownOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  disabled={option === 'Current' && dropdownSelections.first === 'Current'}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
            {dropdownSelections.second !== 'Current' && !isCustomSelected.second && (
              <Select
                disabled={!needSecondRef}
                labelId="prev-next-curr-2"
                id="second-dropdown"
                value={`${Math.abs(windowFnValues.standingSlidingNextInc ?? 999)}`}
                onChange={handleDropdownChangeForRow}
                name="second"
                sx={{ ...dropDownSelectStyle, minWidth: '60px' }}
              >
                {values.map((option) => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            )}
            {dropdownSelections.second !== 'Current' && isCustomSelected.second && (
              <TextField
                disabled={!needSecondRef}
                type="number"
                value={Math.abs(inputs.second)}
                name="second"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                  input: { style: { height: '25px' } },
                  htmlInput: { max: 100 },
                }}
                sx={{
                  width: '95%',
                  '& .MuiInputBase-root': {
                    height: '2rem',
                    fontSize: '11px',
                  },
                  '& .MuiTextField-root': {
                    outline: 'none',
                    border: 'none',
                  },
                  border: 'none',
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#2bb9bb',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '16.5px 14px', // Consistent padding for all browsers
                  },
                  // Firefox-specific styling
                  '@supports (-moz-appearance: none)': {
                    '& .MuiOutlinedInput-input': {
                      padding: '16.5px 2px 16.5px 14px',
                    },
                  },
                }}
                onBlur={handleInputChange}
                onChange={onInputChange}
              />
            )}
          </Box>
        </div>

        <Typography
          sx={{
            fontSize: '12px',
            paddingLeft: '15px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            marginTop: '12px',
          }}
        >
          Aggregation
        </Typography>
        <FormControl fullWidth>
          <Select
            onChange={(e) =>
              setWindowFnValues((prevState: any) => ({
                ...prevState,
                standingSlidingAggregation: e.target.value,
              }))
            }
            value={windowFnValues.standingSlidingAggregation}
            sx={{ ...dropDownSelectStyle, margin: '3px 15px 7px 15px' }}
          >
            {standingSlidingAggregation.map((data, index) => (
              <MenuItem key={index} value={data} sx={{ fontSize: '12px' }}>
                {data}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default StandingSlidingOptions;
